
import React from "react";
import { NavLink } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";

interface HelpSectionProps {
  isCollapsed: boolean;
  onClick?: () => void;
}

const HelpSection: React.FC<HelpSectionProps> = ({ isCollapsed, onClick }) => {
  if (isCollapsed) return null;

  return (
    <div className="glass-card p-3 rounded-lg">
      <p className="text-xs text-gray-600 dark:text-gray-400 mb-2">Need help?</p>
      <Button variant="link" asChild className="p-0 h-auto">
        <NavLink
          to="/app/support"
          className="flex items-center gap-2 text-sm font-medium text-primary"
          onClick={onClick}
        >
          <LifeBuoy size={16} />
          <span>Get Support</span>
        </NavLink>
      </Button>
    </div>
  );
};

export default HelpSection;
